'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = InlineStripeForm;

require('./inline-stripe-form.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _loader_2x = require('common/images/loader_@2x.gif');

var _loader_2x2 = _interopRequireDefault(_loader_2x);

var _name_icon = require('./assets/name_icon.svg');

var _name_icon2 = _interopRequireDefault(_name_icon);

var _monthSelect = require('./month-select.jsx');

var _monthSelect2 = _interopRequireDefault(_monthSelect);

var _yearSelect = require('./year-select.jsx');

var _yearSelect2 = _interopRequireDefault(_yearSelect);

var _cardsDisplay = require('./cards-display.jsx');

var _cardsDisplay2 = _interopRequireDefault(_cardsDisplay);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function InlineStripeForm(p) {

    var propTypes = {
        'card': _react.PropTypes.object,
        'onCardholderNameChange': _react.PropTypes.func,
        'onCardNumberChange': _react.PropTypes.func,
        'onExpMonthChange': _react.PropTypes.func,
        'onExpYearChange': _react.PropTypes.func,
        'onCvvChange': _react.PropTypes.func,
        'onZipChange': _react.PropTypes.func,
        'onStart': _react.PropTypes.func
    };

    var buttonProps = {
        buttonText: 'Start 30-day free trial',
        buttonColor: 'cerulean'
    };

    var buttonOrLoader = void 0;
    if (p.isProcessing) {
        buttonOrLoader = _react2['default'].createElement(
            'div',
            { className: 'loader' },
            _react2['default'].createElement('img', { src: _loader_2x2['default'] })
        );
    } else {
        buttonOrLoader = _react2['default'].createElement(_button2['default'], _extends({}, buttonProps, { onClick: p.onStart }));
    }

    var errors = p.errors || { card: {}, global: '' };
    var cardErrorKeys = Object.keys(errors.card);
    var cardErrorMap = {};
    cardErrorKeys.map(function (key) {
        cardErrorMap[key] = _react2['default'].createElement(
            'div',
            { className: 'error' },
            errors.card[key]
        );
    });

    var nameClasses = {
        'cardholder-name': true,
        'error': !!errors.card.name
    };

    var numberClasses = {
        'card-number': true,
        'error': !!errors.card.number
    };

    var cvvClasses = {
        'cvv': true,
        'error': !!errors.card.cvv
    };

    var zipClasses = {
        'zip-code': true,
        'error': !!errors.card.zip
    };

    return _react2['default'].createElement(
        'form',
        { className: 'm-inline-stripe-form' },
        _react2['default'].createElement('input', { className: (0, _classnames2['default'])(nameClasses), placeholder: 'Cardholder Name', value: p.card.name, onChange: p.onCardholderNameChange }),
        _react2['default'].createElement('img', { className: 'name-icon', src: _name_icon2['default'] }),
        cardErrorMap.name,
        _react2['default'].createElement(
            'div',
            { className: 'card-number-wrapper' },
            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(numberClasses), placeholder: '1234 4567 8912 3456', value: p.card.number, onChange: p.onCardNumberChange }),
            _react2['default'].createElement(_cardsDisplay2['default'], { type: p.card.type }),
            cardErrorMap.number
        ),
        _react2['default'].createElement(
            'div',
            { className: 'inline-fields' },
            _react2['default'].createElement(_monthSelect2['default'], { value: p.card.expMonth, onChange: p.onExpMonthChange }),
            _react2['default'].createElement(_yearSelect2['default'], { value: p.card.expYear, onChange: p.onExpYearChange }),
            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(cvvClasses), placeholder: 'CVV', value: p.card.cvv, onChange: p.onCvvChange }),
            _react2['default'].createElement('input', { className: (0, _classnames2['default'])(zipClasses), placeholder: 'Zip Code', value: p.card.zip, onChange: p.onZipChange }),
            cardErrorMap.cvv,
            ' ',
            cardErrorMap.zip
        ),
        buttonOrLoader,
        _react2['default'].createElement(
            'div',
            { className: 'error' },
            errors.global
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/inline-stripe-form.jsx
 ** module id = 1118
 ** module chunks = 0
 **/